const messages = {
  title: 'Before and after',
  subTitle: 'Learn more about the thousands of patients who today have the smile of their dreams.',
  beforeLbl: 'BEFORE',
  afterLbl: 'AFTER'
}

export default messages
